/* eslint-disable react/prop-types */ // TODO: add props
import { Fragment } from 'react';
import { useProfile, profileUtils } from 'edrolo/domains/profile';

const PermissionGate = ({ permission, children, renderMessage }) => {
  const { profile } = useProfile(!!'immutable');

  if (profileUtils.hasPermission(profile, permission)) {
    return <Fragment>{children}</Fragment>;
  }

  return <Fragment>{renderMessage()}</Fragment>;
};

export default PermissionGate;
